var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlackInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    rx: 48,
    fill: "#0F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.234 36.002c.875-.004 1.75.005 2.626.026l.233.008c.269.01.534.022.854.036 1.277.06 2.148.262 2.913.558.792.305 1.459.718 2.126 1.385a5.89 5.89 0 0 1 1.384 2.125c.296.764.498 1.637.558 2.914.014.319.026.585.036.854l.007.233c.021.875.03 1.75.027 2.625l.002.895v1.572c.002.876-.007 1.752-.028 2.627l-.007.233c-.01.269-.022.534-.036.854-.06 1.277-.264 2.148-.56 2.913a5.86 5.86 0 0 1-1.383 2.126 5.898 5.898 0 0 1-2.126 1.384c-.765.296-1.636.498-2.913.558-.32.014-.585.026-.854.036l-.233.007c-.875.021-1.75.03-2.626.027l-.895.002h-1.571a95.04 95.04 0 0 1-2.627-.028l-.233-.007c-.285-.01-.57-.023-.854-.036-1.277-.06-2.148-.264-2.913-.56-.801-.3-1.527-.773-2.126-1.383a5.884 5.884 0 0 1-1.384-2.126c-.297-.765-.498-1.636-.558-2.913-.014-.284-.026-.57-.036-.854l-.006-.233a95.045 95.045 0 0 1-.03-2.627v-2.467c-.004-.875.005-1.75.026-2.625l.008-.233c.01-.269.022-.535.037-.854.06-1.278.261-2.148.557-2.914.302-.8.776-1.526 1.388-2.124a5.874 5.874 0 0 1 2.123-1.386c.766-.296 1.636-.498 2.914-.558l.854-.036.233-.006a94.95 94.95 0 0 1 2.626-.03l2.467.002Zm-1.234 6A6 6 0 1 0 48 54 6 6 0 0 0 48 42Zm0 2.4a3.6 3.6 0 1 1 .001 7.198 3.6 3.6 0 1 1 0-7.2v.001Zm6.3-4.2a1.5 1.5 0 0 0 0 2.997 1.5 1.5 0 1 0 0-3v.002Z",
    fill: "#121517"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackInstagram);
export default __webpack_public_path__ + "static/media/blackInstagram.3253bd5a30f342eac2856fea4729bfd4.svg";
export { ForwardRef as ReactComponent };